import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.8572 8C9.5159 8 8.42859 9.08731 8.42859 10.4286C8.42859 11.7698 9.5159 12.8571 10.8572 12.8571C12.1984 12.8571 13.2857 11.7698 13.2857 10.4286C13.2857 9.08731 12.1984 8 10.8572 8ZM6.42859 10.4286C6.42859 7.98274 8.41133 6 10.8572 6C13.303 6 15.2857 7.98274 15.2857 10.4286C15.2857 12.8744 13.303 14.8571 10.8572 14.8571C8.41133 14.8571 6.42859 12.8744 6.42859 10.4286Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.8572 14.8571C8.56912 14.8571 6.71429 16.712 6.71429 19C6.71429 19.5523 6.26658 20 5.71429 20C5.16201 20 4.71429 19.5523 4.71429 19C4.71429 15.6074 7.46455 12.8571 10.8572 12.8571C14.2498 12.8571 17 15.6074 17 19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19C15 16.712 13.1452 14.8571 10.8572 14.8571Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.71429 8.85715C5.3198 8.85715 5 9.17694 5 9.57143C5 9.96592 5.3198 10.2857 5.71429 10.2857C6.10878 10.2857 6.42857 9.96592 6.42857 9.57143C6.42857 9.17694 6.10878 8.85715 5.71429 8.85715ZM3 9.57143C3 8.07237 4.21523 6.85715 5.71429 6.85715C7.21334 6.85715 8.42857 8.07237 8.42857 9.57143C8.42857 11.0705 7.21334 12.2857 5.71429 12.2857C4.21523 12.2857 3 11.0705 3 9.57143Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.71429 12.2857C4.84641 12.2857 4.14285 12.9893 4.14285 13.8571C4.14285 14.4094 3.69514 14.8571 3.14285 14.8571C2.59057 14.8571 2.14285 14.4094 2.14285 13.8571C2.14285 11.8847 3.74184 10.2857 5.71429 10.2857C7.68673 10.2857 9.28571 11.8847 9.28571 13.8571C9.28571 14.4094 8.83799 14.8571 8.28571 14.8571C7.73343 14.8571 7.28571 14.4094 7.28571 13.8571C7.28571 12.9893 6.58216 12.2857 5.71429 12.2857Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19 4C19.5523 4 20 4.44772 20 5V9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9V5C18 4.44772 18.4477 4 19 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22 7C22 7.55228 21.5523 8 21 8L17 8C16.4477 8 16 7.55228 16 7C16 6.44772 16.4477 6 17 6L21 6C21.5523 6 22 6.44772 22 7Z",
			fill: "currentColor"
		})
	]
});
export default SvgGroupAdd;
